import { ProgramPage as Page } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../../routes/types';

export const ProgramPage = () => (
  <Page
    learningPageLink={AppRoutesPaths.Learning}
    programsPageLink={AppRoutesPaths.Programs}
    notFoundPageLink={AppRoutesPaths.NotFound}
  />
);
